import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ImageAdd = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 20 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9094 0.75C15.9094 0.335786 15.5737 0 15.1594 0C14.7452 0 14.4094 0.335786 14.4094 0.75V4.13093H11.0356C10.6214 4.13093 10.2856 4.46672 10.2856 4.88093C10.2856 5.29514 10.6214 5.63093 11.0356 5.63093H14.4094V9.01198C14.4094 9.4262 14.7452 9.76198 15.1594 9.76198C15.5737 9.76198 15.9094 9.4262 15.9094 9.01198V5.63094L19.0357 5.63099C19.4499 5.631 19.7857 5.29522 19.7857 4.881C19.7857 4.46679 19.4499 4.131 19.0357 4.13099L15.9094 4.13094V0.75ZM3.79494 1.45832C1.67646 1.45832 0 3.22495 0 5.35293V15.835C0 17.9629 1.67646 19.7296 3.79494 19.7296H13.9447C16.0632 19.7296 17.7397 17.9629 17.7397 15.835V14.9133C17.7397 14.6749 17.6263 14.4506 17.4342 14.3093L12.623 10.7684C12.3355 10.5569 11.9388 10.5772 11.6745 10.8171L3.52381 18.2129C2.40131 18.0737 1.5 17.0815 1.5 15.835V5.35293C1.5 4.00747 2.55007 2.95832 3.79494 2.95832H7.03552C7.44974 2.95832 7.78552 2.62253 7.78552 2.20832C7.78552 1.7941 7.44974 1.45832 7.03552 1.45832H3.79494ZM13.9447 18.2296H5.73759L12.2281 12.3402L16.2397 15.2926V15.835C16.2397 17.1804 15.1896 18.2296 13.9447 18.2296ZM7.8213 8.42184C7.8213 9.26896 7.16849 9.87255 6.46412 9.87255C5.75974 9.87255 5.10693 9.26896 5.10693 8.42184C5.10693 7.57473 5.75974 6.97113 6.46412 6.97113C7.16849 6.97113 7.8213 7.57473 7.8213 8.42184ZM9.3213 8.42184C9.3213 10.0515 8.0421 11.3726 6.46412 11.3726C4.88614 11.3726 3.60693 10.0515 3.60693 8.42184C3.60693 6.79221 4.88614 5.47113 6.46412 5.47113C8.0421 5.47113 9.3213 6.79221 9.3213 8.42184Z"
        fill={color}
      />
    </svg>
  )
})

export default ImageAdd
